PJQ.collections.changeRequests = PJQ.collections.changeRequests ? PJQ.collections.changeRequests : {};
PJQ.models.changeRequests = PJQ.models.changeRequests ? PJQ.models.changeRequests : {};
PJQ.views.changeRequests = PJQ.views.changeRequests ? PJQ.views.changeRequests : {};

PJQ.modules.changeRequests = {
    routes: [
        {
            route: 'projects/:projectId/changerequests',
            name: 'changerequests',
            callback: function (projectId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests");
            }
        },
        {
            route: 'projects/:projectId/changerequests/:changeRequestId',
            name: 'changerequest',
            callback: function (projectId, changeRequestId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    changeRequestId: parseInt(changeRequestId)
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/rfq',
            name: 'rfq1',
            callback: function (projectId, changeRequestId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    view: 'rfq'
                });
            }
        },
        {
            route: 'projects/:projectId/rfq/:rfqId',
            name: 'rfq2',
            callback: function (projectId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    view: 'rfq',
                    rfqId: parseInt(rfqId),
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/rfq/:rfqId',
            name: 'rfq3',
            callback: function (projectId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    rfqId: parseInt(rfqId),
                    view: 'rfq'
                });
            }
        },
        {
            route: 'projects/:projectId/changerequests/:changeRequestId/rfq/:rfqId',
            name: 'rfq4',
            callback: function (projectId, changeRequestId, rfqId) {
                PJQ.modules.projectWall.initProjectNavigator(parseInt(projectId), "changerequests", {
                    changeRequestId: parseInt(changeRequestId),
                    rfqId: parseInt(rfqId),
                    view: 'rfq'
                });
            }
        }
    ]
};

PJQ.app.addRoutes(PJQ.modules.changeRequests.routes);